module.exports = __webpack_public_path__ + "img/fbxq.5a1fafea.png";